/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Filter, SQRFSvg, StationSvg, TableSearch } from "../../../common/svg/AllSvg";
import { url } from "../../../../shared/utils/url";
import useAxios from "../../../../shared/hooks/use-axios";
import NoSearch from "../../../common/form/NoSearch";
import EmptyList from "../../../common/form/EmptyList";
import Error from "../../../common/form/Error";
import PropertyFilter from "./PropertyFilter";
import SecondaryBtn from "../../../common/form/SecondaryBtn";
import { useDeviceType } from "../../../../shared/utils/useDeviceType";
import PaginationComponent from "../../../common/form/PaginationComponent";
import Img1 from "../../../../assets/images/property1.png";
import Img2 from "../../../../assets/images/property2.png";
import Img3 from "../../../../assets/images/property3.png";
import Img4 from "../../../../assets/images/property4.png";
import Img5 from "../../../../assets/images/property5.png";
import Img6 from "../../../../assets/images/property6.png";
import Img7 from "../../../../assets/images/property7.png";
import Img8 from "../../../../assets/images/property8.png";
import Img9 from "../../../../assets/images/property9.png";

const PropertyList = () => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [category, setCategory] = useState<any[]>([])
    const [status, setStatus] = useState<any[]>([])
    const [propertyData, setPropertyData] = useState<any[]>([])
    const [search, setSearch] = useState<string>("")
    const [debouncedValue, setDebouncedValue] = useState<string>(search);
    const [filterOpen, setFilterOpen] = useState<boolean>(false)
    const [selectCategory, setSelectCategory] = useState<any[]>([])
    const [selectStatus, setSelectStatus] = useState<any[]>([])
    const [selectStation, setSelectStation] = useState<any[]>([])
    const [minimumArea, setMinimumArea] = useState<string>("")
    const [maximumArea, setMaximumArea] = useState<string>("")
    const [sts, setSts] = useState<any[]>([])
    const [animation, setAnimation] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true)
    const [loading1, setLoading1] = useState<boolean>(true)
    const [loading2, setLoading2] = useState<boolean>(true)
    const [loading3, setLoading3] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const [searchFocus, setSearchFocus] = useState<boolean>(false)
    const [hover, setHover] = useState<any>("")
    const loaderData: any[] = [1, 2, 3, 4, 5]
    const { t } = useTranslation('common');
    const isMobile = useDeviceType();
    const [page, setPage] = useState<number>(1);
    const [total, setTotal] = useState<number>(0);
    const [size, setSize] = useState<any>({ label: `10 ${t("recruitment.home.per_page")}`, value: "10" });
    let totalPages: number = Math.ceil(total / +size?.value);

    const getCategory = async () => {
        try {
            setLoading1(true)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url.property_type_list}`);

            if (res && res.status === 200 && res?.data?.length > 0) {
                setCategory(res?.data)
                setLoading1(false)
            } else if (res && res.status === 200 && res?.data?.length === 0) {
                setLoading1(false)
            }
        } catch (error) {
            setLoading1(false)
            console.error("error while fetching category", error);
        }
    }

    const getStatus = async () => {
        setLoading3(true)
        setStatus(
            [
                { id: 1, name: "Vacant" },
                { id: 2, name: "Occupied" }
            ]
        )
        setLoading3(false)
    }

    const getStations = async () => {
        try {
            setLoading2(true)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.location_list}`);
            if (res && res?.status === 200 && res?.data?.length > 0) {
                const arr: any[] = Array.isArray(res?.data) && res?.data?.map((item: any) => ({ label: item?.name, value: item?.code, id: item?.id }));
                setSts(arr)
                setLoading2(false)
            } else if (res && res?.status === 200 && res?.data?.length === 0) {
                setLoading2(false)
            }

        } catch (error) {
            setLoading2(false)
            console.error("error while feching stations", error);
        }
    }

    useEffect(() => {
        !!lang && getCategory();
        !!lang && getStatus();
        !!lang && getStations();
    }, [lang])

    const getProperties = async () => {
        try {
            setLoading(true)
            setIsError(false)
            interface PayloadType {
                property_type?: any[];
                status?: any[];
                location?: any[];
                search_text?: string;
                min_area?: string;
                max_area?: string;
            }
            let payload: PayloadType = {
                property_type: selectCategory?.length > 0 ? selectCategory : undefined,
                status: selectStatus?.length > 0 ? selectStatus : undefined,
                location: selectStation?.length > 0 ? selectStation : undefined,
                search_text: debouncedValue || undefined
            };
            if (minimumArea) {
                payload.min_area = minimumArea;
            }
            if (maximumArea) {
                payload.max_area = maximumArea;
            }

            const res: any = await useAxios.post(
                `/${!!lang ? lang : "en"}${url.search_property}?page=${page}&size=${+size?.value}`,
                payload
            );

            if (res && res.status === 200) {
                setPropertyData(res?.data?.results)
                setTotal(res?.data?.count)
                setLoading(false)
            }
        } catch (error: any) {
            setIsError(true)
            setLoading(false)
            console.error("error while fetching properties", error);
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(search);
        }, 500);

        return () => clearTimeout(timer);
    }, [search]);

    useEffect(() => {
        window.scrollTo(0, 0);
        !!lang && getProperties();
    }, [lang, debouncedValue, selectStatus, selectCategory, selectStation, page, size, minimumArea, maximumArea])


    useEffect(() => {
        if (window.innerWidth <= 640 && filterOpen) {
            document.body.style.overflow = "hidden";
        } else {
            setFilterOpen(false)
            document.body.style.overflow = "auto";
        }
    }, [window.innerWidth, filterOpen])

    useEffect(() => {
        if (animation) {
            setTimeout(() => {
                setAnimation(false)
            }, 500)
        }
    }, [animation])

    return (
        <>
            {/* Backdrop */}
            <div>
                <span
                    className={`fixed top-0 left-0 z-20 ${filterOpen ? "block" : "hidden"
                        } h-screen w-full bg-[rgba(216,216,216,0.60)] sm:hidden backdrop-blur-[15px]`}
                    onClick={() => setFilterOpen(!filterOpen)}
                ></span>
            </div>

            <div className=" flex items-center justify-center px-[18px] xlsm:px-[25px] xlx:px-[45px] w-full">
                <div className="h-full py-[33px] grid grid-cols-1 w-[1200px] xlx:w-[1384px]">
                    <div className="w-full flex">
                        <div className="w-[250px] xlx:w-[355px] border-r border-primary border-opacity-[0.2] h-full sm:flex hidden">
                            {/* filter */}
                            <PropertyFilter category={category} status={status} selectCategory={selectCategory} selectStatus={selectStatus} setSelectCategory={setSelectCategory} setSelectStatus={setSelectStatus} selectStation={selectStation} setSelectStation={setSelectStation} mobile={false} loading1={loading1} loading2={loading2} sts={sts} loading3={loading3} setMinimumArea={setMinimumArea} setMaximumArea={setMaximumArea} minimumArea={minimumArea} maximumArea={maximumArea} />
                        </div>

                        <div className="pb-[15px] pt-[5px] xlx:pt-[15px] xlx:pb-[30px] w-full sm:w-[calc(100%-250px)] xlx:w-[calc(100%-355px)] sm:pl-[25px] flex flex-col gap-[20px] xlx:gap-[25px]">
                            <div className="flex md:items-center justify-between w-full md:flex-row flex-col gap-[13px]">
                                <div className="flex items-center justify-between w-full">
                                    <h3 className="text-primaryText dark:text-white font-bold text-[1.8rem]">{(propertyData?.length > 0 && (selectCategory?.length > 0 || selectStatus?.length > 0 || selectStation?.length > 0 || !!search)) ? `${lang === "en" ? `Showing Result for ${propertyData?.length} Filter` : lang === "hi" ? `${propertyData?.length} फ़िल्टर के लिए परिणाम दिखाया जा रहा है` : `${propertyData?.length} फिल्टरसाठी परिणाम दर्शवित आहे`}` : `${t("corporate.content_pages.properties.shops_rent")}`}</h3>

                                    <button className="bg-white dark:bg-bgDarkDull shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12),0px_8px_8px_-4px_rgba(24,39,75,0.08)] min-w-[40px] h-[40px] rounded-[8px] flex items-center justify-center sm:hidden focus:shadow-[0px_14px_64px_rgba(24,39,75,0.12),0px_8px_22px_rgba(24,39,75,0.12)] hover:bg-white focus:bg-white border border-transparent focus:border-[#D7D8DD] hover:border-[#D7D8DD] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => setFilterOpen(true)}>
                                        <Filter className="xlx:w-auto xlx:h-auto w-[17px] h-[17px] fill-[#1C1B1F] dark:fill-white" />
                                    </button>
                                </div>

                                <div className="flex items-center gap-[10px] md:w-auto w-full justify-end">
                                    <div className={`border dark:border-[rgb(134,134,134,0.3)] border-[rgba(134,134,134,0.15)] h-[40px] xlx:h-[45px] px-[12px] xlx:px-[15px] flex items-center gap-[8px] xlx:gap-[12px] rounded-[12px] w-full xs:w-[315px] ${searchFocus && "shadow-lg"} hover:shadow-lgdark:hover:border-[#ffffff5e]`}>
                                        <TableSearch className="xlx:w-[18px] xlx:min-w-[18px] xlx:h-[18px] min-w-[15px] w-[15px] h-[15px] fill-blackDull dark:fill-white opacity-[0.7]" />

                                        <input type="text" className="text-opacity-[0.7] text-blackDull font-medium placeholder:text-blackDull placeholder:text-opacity-[0.7] text-sm leading-snug w-full bg-transparent dark:text-textBlackDull placeholder:dark:text-textBlackDull" placeholder={t("corporate.content_pages.properties.search")} autoComplete="off" value={search} onChange={(e: any) => setSearch(e.target.value)} onFocus={() => setSearchFocus(true)} onBlur={() => setSearchFocus(false)} />
                                    </div>
                                </div>
                            </div>

                            {loading ?
                                <div className="grid grid-cols-1 mmm:grid-cols-2 lgl:grid-cols-3 gap-[20px]">
                                    {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                                        <div className="w-full animate-pulse rounded-[15px] border border-[#ECF0F8] dark:border-[#454545]" key={index}>
                                            <div className="rounded-t-[15px] w-full h-[190px] md:h-[245px] bg-gray-200 dark:bg-gray-700"></div>

                                            <div className='px-[20px] xlx:px-[22px] py-[16px] xlx:py-[18px] flex flex-col'>
                                                <div className="w-[80%] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700 mb-[8px]"></div>
                                                <div className="w-[80%] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700 mb-[6px]"></div>
                                                <div className="w-[60%] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                :
                                <>
                                    {isError ? <Error /> : <>
                                        {propertyData?.length > 0 && <div className="flex flex-col gap-[15px]"> <div className="grid grid-cols-1 mmm:grid-cols-2 lgl:grid-cols-3 gap-[20px]">
                                            {Array.isArray(propertyData) && propertyData?.map((item: any, index: number) => (
                                                <div className="w-full relative" key={index} onMouseLeave={() => setHover("")}>
                                                    <button className="rounded-[15px] w-full bg-[#FCFCFC] dark:bg-[#3d4050] border border-[#ECF0F8] dark:border-[#454545]" onMouseEnter={() => setHover(index)} onFocus={() => !isMobile && setHover(index)} onClick={() => setHover(index)} onBlur={() => setHover(null)}>
                                                        <div className="absolute top-0 left-0 p-[16px] flex items-start justify-start">
                                                            <div className={`border border-[#C8C8C8] dark:border-[#454545] bg-opacity-[0.8] flex items-center justify-center px-[11px] h-[22px] rounded-[10px] text-white text-xs font-bold uppercase whitespace-nowrap ${item?.lease_status === 'Available for Lease' ? "bg-[#10B85D]" : "bg-[#B81013]"}`}>{item?.lease_status === 'Available for Lease' ? "Vacant" : "Occupied"}</div>
                                                        </div>
                                                        <img src={!!item?.image?.file ? item?.image?.file : (index + 1) % 10 === 1 ? Img1 : (index + 1) % 10 === 2 ? Img2 : (index + 1) % 10 === 3 ? Img3 : (index + 1) % 10 === 4 ? Img4 : (index + 1) % 10 === 5 ? Img5 : (index + 1) % 10 === 6 ? Img6 : (index + 1) % 10 === 7 ? Img7 : (index + 1) % 10 === 8 ? Img8 : (index + 1) % 10 === 9 ? Img9 : Img1} alt={item?.name} className="rounded-t-[15px] w-full h-[195px]" />
                                                        <div className="px-[20px] xlx:px-[22px] py-[16px] xlx:py-[18px] flex flex-col">
                                                            <h4 className="text-primaryText dark:text-white font-bold mb-[8px] text-left">{item?.name}</h4>
                                                            <div className="flex gap-[8px] mb-[6px]"><StationSvg className="fill-blackDull dark:fill-textBlackDull min-w-[16px] mt-[1px]" /> <h6 className="text-blackDull dark:text-textBlackDull font-semibold">{item?.location} {t("corporate.content_pages.properties.metro_station")}</h6></div>
                                                            <div className="flex items-center gap-[8px]"><SQRFSvg /> <h6 className="text-blackDull dark:text-textBlackDull font-semibold">{item?.area} {t("corporate.content_pages.properties.sqft")}</h6></div>
                                                        </div>
                                                    </button>

                                                    <div className={`${hover === index ? "shadow-[0px_8px_22px_0px_rgba(24,39,75,0.12),0px_14px_64px_0px_rgba(24,39,75,0.12)] dark:shadow-[0px_4px_6px_-4px_#ffffff1f,0px_8px_8px_-4px_#ffffff14] border border-transparent dark:bg-bgDarkDull bg-white absolute left-0 right-0 top-0 z-[1] rounded-[15px] w-full" : "hidden"}`}>
                                                        <div className="absolute top-0 left-0 p-[16px] flex items-start justify-start">
                                                            <div className={`border border-[#C8C8C8] dark:border-[#454545] bg-opacity-[0.8] flex items-center justify-center px-[11px] h-[22px] rounded-[10px] text-white text-xs font-bold uppercase whitespace-nowrap ${item?.lease_status === 'Available for Lease' ? "bg-[#10B85D]" : "bg-[#B81013]"}`}>{item?.lease_status === 'Available for Lease' ? "Vacant" : "Occupied"}</div>
                                                        </div>
                                                        <img src={!!item?.image?.file ? item?.image?.file : (index + 1) % 10 === 1 ? Img1 : (index + 1) % 10 === 2 ? Img2 : (index + 1) % 10 === 3 ? Img3 : (index + 1) % 10 === 4 ? Img4 : (index + 1) % 10 === 5 ? Img5 : (index + 1) % 10 === 6 ? Img6 : (index + 1) % 10 === 7 ? Img7 : (index + 1) % 10 === 8 ? Img8 : (index + 1) % 10 === 9 ? Img9 : Img1} alt={item?.name} className="rounded-t-[15px] w-full h-[195px]" />
                                                        <div className="px-[20px] xlx:px-[22px] py-[16px] xlx:py-[18px] flex flex-col">
                                                            <h4 className="text-primaryText dark:text-white font-bold mb-[8px] text-left">{item?.name}</h4>
                                                            <div className="flex gap-[8px] mb-[6px]"><StationSvg className="fill-blackDull dark:fill-textBlackDull min-w-[16px] mt-[1px]" /> <h6 className="text-blackDull dark:text-textBlackDull font-semibold">{item?.location} Metro Station</h6></div>
                                                            <div className="flex items-center gap-[8px]"><SQRFSvg /> <h6 className="text-blackDull dark:text-textBlackDull font-semibold">{item?.area} sqft.</h6></div>
                                                        </div>
                                                        {item?.lease_status === 'Available for Lease' ?
                                                            <div className={`${hover === index ? "opacity-[1]" : "opacity-0 hidden"} px-[20px] xlx:px-[22px] pb-[16px]`}>
                                                                <SecondaryBtn
                                                                    css="!rounded-[6px] font-bold w-full uppercase"
                                                                    title={t("corporate.content_pages.properties.enquire_now")}
                                                                    onClick={() =>
                                                                        window.open(`${url?.baseUrl}/${lang ? lang : "en"}/property-enquiry/${item?.id}/`, '_blank')
                                                                    }
                                                                />
                                                            </div>
                                                            :
                                                            ''
                                                        }
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                            <div className="flex items-center justify-center w-full mt-[10px]">
                                                <PaginationComponent
                                                    page={page}
                                                    total={totalPages}
                                                    setPage={setPage}
                                                />
                                            </div>
                                        </div>}

                                        {((selectCategory?.length === 0 && selectStatus?.length === 0 && selectStation?.length === 0 && !!!search) && propertyData?.length === 0) &&
                                            <EmptyList />
                                        }

                                        {((selectCategory?.length > 0 || selectStatus?.length > 0 || selectStation?.length > 0 || !!search) && propertyData?.length === 0) &&
                                            <NoSearch onClick={() => { setSelectCategory([]); setSelectStation([]); setSearch(""); }} />
                                        }
                                    </>}
                                </>}
                        </div>
                    </div>
                </div >
            </div >

            <div className={`fixed left-0 right-0 bottom-0 z-50 ${!filterOpen ? "translate-y-full" : ""} h-[500px] w-full bg-white transition duration-400 sm:hidden focus:!outline-none rounded-t-[30px]`}>
                {/* filter */}
                <PropertyFilter category={category} status={status} selectCategory={selectCategory} setSelectCategory={setSelectCategory} selectStatus={selectStatus} setSelectStatus={setSelectStatus} selectStation={selectStation} setSelectStation={setSelectStation} mobile={true} loading1={loading1} loading2={loading2} sts={sts} loading3={loading3} setMinimumArea={setMinimumArea} setMaximumArea={setMaximumArea} minimumArea={minimumArea} maximumArea={maximumArea} />
            </div>
        </>
    );
}

export default PropertyList;